import React from 'react';
import { BaseComponent, IStateBase } from 'components/BaseComponent';
import { ticketService } from 'services/TicketService';
import Grid from '@material-ui/core/Grid/Grid';
import { SvgIcon } from 'components/SvgIcon';

const style = require('../Sidebar/sidebar.css');

interface IState extends IStateBase {
  time: number;
  progress: number;
  minutes: any;
  seconds: any;
  isTimeOver: boolean;
}

// tslint:disable-next-line:variable-name
export class TicketTimer extends BaseComponent<IState, {}> {

  constructor(props: any) {
    super(props);
    this.state = { time: 0, progress: 0, minutes: '', seconds: '', isTimeOver: false };
  }

  componentDidMount() {

    ticketService.getIsOver()
      .bindComponent(this)
      .subscribe(isTimeOver => this.setState({ isTimeOver }));

    ticketService.calculateTime()
      .distinctUntilChanged()
      .bindComponent(this)
      .subscribe(time => {

        let minutes = ('0' + Math.floor(time / 60)).slice(-2);
        let seconds = ('0' + ((time / 60 - Math.floor(time / 60)) * 60).toFixed(0)).slice(-2);
        let progress = 100 - time * 100 / 600;
        this.setState({ time, progress, minutes, seconds });
      });
  }

  render() {
    const { isTimeOver } = this.state;
    return (
      <div className={style.component}>
        <Grid container alignItems={'flex-end'}>
          <Grid item xs={5} sm={12}>
            <span id='booking_label' className='alert'>
              Sua reserva expira em:
            </span>
          </Grid>
          <Grid item xs={7} sm={12}>
            <div id='booking_time' className='time theme-icon'><SvgIcon name='timer_icon' />
              {isTimeOver ? '00' : this.state.minutes} : {isTimeOver ? '00' : this.state.seconds}
            </div>
            <div className='progressBar'>
              <div
                id='booking_countdown_bar'
                className='filledBar theme-button'
                style={{ width: `${100 - this.state.progress}%` }}
              />
            </div>
          </Grid>
          {isTimeOver ?
            <Grid item xs={12}>
              <span className='timeOver'>Sua reserva expirou, recarregue a página para continuar</span>
            </Grid>
            : null
          }
        </Grid>
      </div>

    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Cart/TicketTimer/index.tsx